module.exports = __webpack_public_path__ + "assets/img/play.487aedfc.svg";